import React, { useEffect, useState } from "react";
import {CityCard} from "@/components/cards/CityCard";
import styles from "@/pages/css/CitiesPage.module.css";
import { CityData } from "@/types";
import { useFetchAllEntities } from "@/utils/fetchData";
import { getEntityIdPair } from "@/utils/getEntityPairId";
import { useSelector } from "react-redux";
import { RootState } from "@/store/store";
import { LoadingPageAnimation } from "@/components/addons/LoadingPageAnimation";

export const CitiesPage: React.FC = () => {
    const { getAllCities } = useFetchAllEntities();
    const [cities, setCities] = useState<CityData[]>([]);
    const {cities: citiesData, citiesFetched} = useSelector((state: RootState) => state.entity);
    const ao = useSelector((state: RootState) => state.entity.userAo);

    useEffect(() => {
        const body = ao ? {...getEntityIdPair("ao", null, ao)} : {};
        getAllCities.mutate(body);
    }, []);

    useEffect(() => {
        setCities(citiesData);
    }, [citiesData]);
    
    return (
        <>
            {citiesFetched ? (
                <div className={styles.container}>
                    {cities.map((city) => (
                        <CityCard key={city.id} city={city} />
                    ))}
                </div>
            ) : (
                <div className={styles.loadingContainer}>
                    <LoadingPageAnimation />
                </div>
            )}
        </>
    );
};
